<template>
  <b-overlay :show="load" rounded="xl">
    <b-row>
      <b-col lg="12">
        <form-wizard
          color="#ce7b2c"
          :title="null"
          :subtitle="null"
          :finish-button-text="$t('site.finish')"
          :back-button-text="$t('site.back')"
          :next-button-text="$t('site.next')"
          class="steps-transparent mb-3"
          @on-complete="formSubmitted"
        >
          <b-card>
            <b-alert variant="danger" show v-if="resRrrors">
              <h4 class="alert-heading">{{ $t("site.error") }}</h4>
              <div
                class="alert-body"
                v-for="(rror, index) in resRrrors"
                :key="index"
              >
                <span>{{ index + 1 }} -</span> <span>{{ rror[0] }}</span>
              </div>
            </b-alert>
            <!-- edu-courses tab -->
            <tab-content
              :title="$t('addwizard.contact_details')"
              :before-change="() => validateStep('contact_details')"
            >
              <contact-details ref="contact_details" />
            </tab-content>
            <tab-content
              :title="$t('addwizard.course_selection')"
              :before-change="() => validateStep('course_selection')"
            >
              <course-selection ref="course_selection" />
            </tab-content>
            <tab-content
              :title="$t('addwizard.education_background')"
              :before-change="() => validateStep('education_background')"
            >
              <educationbackground ref="education_background" />
            </tab-content>

            <tab-content
              :title="$t('addwizard.personal_details')"
              :before-change="() => validateStep('personal_details')"
            >
              <personal-details ref="personal_details" />
            </tab-content>

            <!-- edu-courses tab -->
          </b-card>
        </form-wizard>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import Swal from "sweetalert2";

// import additionalInformation from "./components/additional_information.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import educationbackground from "./components/education_background.vue";
import personalDetails from "./components/personal_details.vue";
import password from "./components/password.vue";
import contactDetails from "./components/contactDetails.vue";
import courseSelection from "./components/course_selection.vue";
import UsersController from "@/Controllers/UsersController";
export default {
  components: {
    FormWizard,
    TabContent,
    courseSelection,
    educationbackground,
    personalDetails,
    password,
    contactDetails,
  },
  data() {
    return {
      sideImg: require("@/assets/images/pages/register-v2.svg"),
      newItem: {},
      load: false,
      resRrrors: null,
    };
  },
  methods: {
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return false;
      if (name == "course_selection") {
        this.newItem.IntakeCode = returnData.data.intake;
        this.newItem.Workload = returnData.data.Workload;
        this.newItem.FirstCourseSelection = returnData.data.first_choice;
        this.newItem.SecondCourseSelection = returnData.data.second_choice;
        this.newItem.FirstCourseLanguageOfStudy =
          returnData.data.FirstCourseLanguageOfStudy;
        this.newItem.SecondCourseLanguageOfStudy =
          returnData.data.SecondCourseLanguageOfStudy;
      } else if (name == "education_background") {
        this.newItem.EducationLevel = returnData.data.AcademicLevel;
        this.newItem.CertificateName = returnData.data.certificate_Name;
        this.newItem.InstitutionName = returnData.data.institution_Name;
        this.newItem.GraduationYear = returnData.data.Year_of_Graduation;
        this.newItem.CPAGrade = returnData.data.Grade_GPA;
        this.newItem.Specialization = returnData.data.specialazation;
        this.newItem.Country = returnData.data.educationCountry;
        this.newItem.CERT = returnData.data.CERT;
      } else if (name == "personal_details") {
        this.newItem.FullName = returnData.data.fullname;
        this.newItem.FullNameAr = returnData.data.ArabicName;
        this.newItem.DOB = returnData.data.BirthDate;
        this.newItem.Gender = returnData.data.gender;
        this.newItem.Race = returnData.data.Race;
        this.newItem.Religion = returnData.data.Religion;
        this.newItem.Citizenship = returnData.data.Citizenship;
        this.newItem.IDPassportNo = returnData.data.ID_Card;
        this.newItem.PHOTO = returnData.data.PHOTO;
        this.newItem.IDCARD = returnData.data.IDCARD;
        this.newItem.IDPassportIssuedCountry =
          returnData.data.IDPassportIssuedCountry;
      } else if (name == "contact_details") {
        this.newItem.email = returnData.data.email;
        this.newItem.PhoneHome = returnData.data.phone_no_home;
        this.newItem.PhoneMCountryCode = returnData.data.countryPhoneCode;
        this.newItem.PhoneMobile = returnData.data.phone_no_mobile;
        this.newItem.MobileHasWhatsApp = returnData.data.whatsapp;
        this.newItem.PostalAddressCountry =
          returnData.data.PostalAddressCountry;
        this.newItem.PostalAddressCity = returnData.data.cityApplicant;
        this.newItem.PostalAddressStreet = returnData.data.streetApplicant;
        this.newItem.PostCode = returnData.data.post_codeApplicant;
        this.newItem.IsPostalAddressSameResidentialAddress =
          returnData.data.residentialAddress;
        this.newItem.ResidentialCountry = returnData.data.residentialAddress;
      }
      return true;
    },
    async formSubmitted() {
      // this.newItem.first_name = this.newItem.FullName;
      // this.newItem.first_name_en = this.newItem.FullNameAr;
      this.newItem.mobile = this.newItem.PhoneMobile;
      this.newItem.nationalities = this.newItem.Citizenship;
      this.newItem.country = this.newItem.PostalAddressCountry;
      this.newItem.birth_date = this.newItem.DOB;
      this.newItem.account_type = "student";
      this.newItem.gender = "male";
      if (this.newItem.Gender == "F") {
        this.newItem.gender = "female";
      }
      this.load = true;
      let res = await new UsersController().sendUserRequest(this.newItem);
      this.load = false;
      if (res.status) {
        Swal.fire({
          icon: "success",
          title: this.$i18n.t("addwizard.registration_been_received"),
          showConfirmButton: false,
          timer: 3000,
        });

        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      } else {
        console.log(res.errors);
        this.resRrrors = res.errors;
        Swal.fire({
          position: "top-start",
          icon: "error",
          title: this.$i18n.t("site.error"),
          text: res.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }

      // if (res.status) this.$router.push({ name: "auth-login" });
    },
  },
};
</script>

<style>
</style>